import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { ArrowRightIcon, NewTeamIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import { colorTextAction } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
const containerCss = "cfngqgu";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const bannerContainerCss = "blqwwxk";
const BannerContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(bannerContainerCss, props.className)} />;
});
const inviteUsersLinkCss = "i4hyfth";
const InviteUsersLink = forwardRef((props, ref) => {
  const as = RouterLink;
  const to = '/app/admin/invitations/new';
  const size = 'small';
  return <Button ref={ref} {...props} as={as} to={to} size={size} className={classNames(inviteUsersLinkCss, props.className)} />;
});
export const Placeholder = () => <Container>
    <NewTeamIcon size="large" color={colorTextAction} />
    <BannerContainer>
      <BodyText inline size="large">
        {I18n.t('publisher.admin.dashboard.section.users.placeholder.description')}
      </BodyText>
    </BannerContainer>
    <InviteUsersLink>
      {I18n.t('publisher.admin.dashboard.section.users.placeholder.link_text')}
      <ArrowRightIcon />
    </InviteUsersLink>
  </Container>;

require("./placeholder.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./placeholder.js");